import _ from 'lodash';
import { STATE_CODES, REMAINDER_EMAIL_MINUTES, REMAINDER_PUSH_NOTIFICATION_MINUTES, OPPORTUNITY_STATUS_DESCRIPTION } from '../constants/common.constants';

export const generateUniqueKey = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0;
    var v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getInitials = (firstName, lastName, middleName) => {
  var text = [''];
  if (firstName) {
    text.push(firstName.trim().toUpperCase()[0]);
  }

  if (middleName) {
    text.push(middleName.trim().toUpperCase()[0]);
  }

  if (lastName) {
    text.push(lastName.trim().toUpperCase()[0]);
  }

  return text.join('');
};

export const getFirstNotNull = (a, b, c) => {
  if (a !== undefined) {
    return a;
  }
  if (b !== undefined) {
    return b;
  }
  return c;
};

export const isResponseSuccess = response => {
  return (
    response &&
    response.status &&
    response.status >= 200 &&
    response.status < 300
  );
};

export const getArrayItemByType = (field, typeField, type, contact) => {
  if (contact && contact[field]) {
    var value = contact[field].find(item => {
      if (item[typeField] === type) {
        return item;
      }

      return undefined;
    });
    if (value !== undefined) {
      return value;
    }
  }

  return null;
};

export const isEmailNull = (type, contact, nullValue) => {
  var value = getArrayItemByType('emailAddresses', 'emailType', type, contact);
  if (value) {
    return value.emailAddress;
  }

  return nullValue;
};

export const isLocalEmailNull = (type, contact, nullValue) => {
  var email = isEmailNull(type, contact, nullValue);
  if (email && email.indexOf('@') !== -1) {
    return email.substring(0, email.indexOf('@'));
  }

  return nullValue;
};

export const formatPhone = (phonenum) => {
  const regexObj = /^(?:\+?1[-. ]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{4})$/;
  if (regexObj.test(phonenum)) {
    const parts = phonenum.match(regexObj);
    let phone = '';

    if (parts[1]) {
      phone += `(${parts[1]})`;
    }

    phone += `${parts[2]}-${parts[3]}`;

    return phone;
  } else {
    // invalid phone number
    return phonenum;
  }
};

export const isPhoneNumberNull = (type, contact, nullValue) => {
  if (contact && contact.phoneNumbers) {
    var value = contact.phoneNumbers.find(phoneNumber => {
      if (phoneNumber && phoneNumber.phoneNumberType === type) {
        return phoneNumber;
      }

      return undefined;
    });
    if (value !== undefined) {
      return formatPhone(value.phoneNumber);
    }
  }

  return nullValue;
};

export const getBestAvailableContactMethod = contact => {
  let contactMethod = {
    type: '',
    number: '',
    email: ''
  };

  // Look through email
  if (_.get(contact, 'emailAddresses.length')) {
    contactMethod = {
      ...contactMethod,
      type: 'email'
    };

    if (isEmailNull('Primary', contact, 0)) {
      contactMethod = {
        ...contactMethod,
        email: isEmailNull('Primary', contact, 0)
      };
    } else if (isEmailNull('Secondary', contact, 0)) {
      contactMethod = {
        ...contactMethod,
        email: isEmailNull('Secondary', contact, 0)
      };
    } else if (isEmailNull('Alternate', contact, 0)) {
      contactMethod = {
        ...contactMethod,
        email: isEmailNull('Alternate', contact, 0)
      };
    }
  }

  // Phone number is present (Phone takes precedence)
  if (_.get(contact, 'phoneNumbers.length')) {
    contactMethod = {
      ...contactMethod,
      type: 'phone'
    };

    if (isPhoneNumberNull('Mobile', contact, 0)) {
      contactMethod = {
        ...contactMethod,
        number: isPhoneNumberNull('Mobile', contact, 0)
      };
    } else if (isPhoneNumberNull('Work', contact, 0)) {
      contactMethod = {
        ...contactMethod,
        number: isPhoneNumberNull('Work', contact, 0)
      };
    } else if (isPhoneNumberNull('Home', contact, 0)) {
      contactMethod = {
        ...contactMethod,
        number: isPhoneNumberNull('Home', contact, 0)
      };
    } else if (isPhoneNumberNull('Other', contact, 0)) {
      contactMethod = {
        ...contactMethod,
        number: isPhoneNumberNull('Other', contact, 0)
      };
    } else if (isPhoneNumberNull('Fax', contact, 0)) {
      contactMethod = {
        ...contactMethod,
        number: isPhoneNumberNull('Fax', contact, 0)
      };
    }
  }

  return contactMethod;
};

export const getEmailLink = (to, subject, body) => {
  function getDelimiter (text) {
    return text.indexOf('?') === -1 ? '?' : '&';
  }

  let text = to ? `mailto:${to}` : null;

  if (subject) {
    text += getDelimiter(text) + 'subject=' + encodeURIComponent(subject);
  }

  if (body) {
    text += getDelimiter(text) + 'body=' + encodeURIComponent(body);
  }

  return text;
};

export const getPhoneLink = text => {
  const phoneLink = text ? `tel:${text}` : null;

  return phoneLink;
};

export const getSmsLink = text => {
  const smsLink = text ? `sms:${text}` : null;
  return smsLink;
};

export const getEmailTemplate = (contactMethod, props) => {
  const fullName = _.get(props, 'activeReferral.fullName', '');
  const leadSources = _.get(props, 'activeReferral.leadSources[0]', '');
  const member = _.get(props, 'userprofile', {});
  const property = _.get(props, 'properties.items[0].property', null);
  const { memberFullName = '', memberEmail = '', memberMobilePhone = '', memberPreferredPhone = '' } = member;
  let subject = '';
  let body = '';
  const phoneNumber = memberMobilePhone || memberPreferredPhone;
  // \n is needed to fix indentation issue in mail for desktop
  if (property && property.address) {
    const { address: { address1 = '', city = '', stateOrProvince = '' } } = property;
    subject = `RE: Your Inquiry for ${address1}, ${city}, ${stateOrProvince}`;
    body = `Hi, ${fullName},
      \nThank you for your inquiry. My name is ${memberFullName}, and I'm very excited to assist you with any specific questions you may have on the home or, perhaps, help you with scheduling a showing of the home.
      \nI'll be following-up shortly with a phone call. In the meantime, please do not hesitate to reach out to me directly at ${memberMobilePhone} or ${memberEmail}.
      \nBest Regards,
      \n${memberFullName} \n${phoneNumber} \n${memberEmail}
    `;
  } else {
    switch (leadSources.subLeadSource) {
      case 'Registration':
        subject = 'Here to offer real estate assistance';
        body = `Hi, ${fullName},
          \nAs you begin the home research process, I am happy to offer you my professional assistance and to be a resource on any homes you are interested in knowing more about.
          \nPlease do not hesitate to reach out to me directly at ${phoneNumber} or ${memberEmail}.
          \nBest regards,
          \n${memberFullName} \n${phoneNumber} \n${memberEmail}
        `;
        break;
      case 'Contact Form':
        subject = 'Available for your real estate questions and needs';
        body = `Hi, ${fullName},
          \nThank you for contacting us!
          \nMy name is ${member.memberFullName} and I'm very exicted to assist you with any specific questions you may have on a specific home or, perhaps help you with any other real estate needs.
          \nI'll be following-up shortly with a phone call. However, in the meantime, please do not hesitate to contact me directly at any time at ${member.memberMobilePhone} or ${member.memberEmail}.
          \nBest regards,
          \n${memberFullName} \n${phoneNumber} \n${memberEmail}
        `;
        break;
      default:
        break;
    }
  }

  return getEmailLink(contactMethod.email, subject, body);
};

export const getItemFromListByName = (list, name) => {
  for (const idx in list) {
    const item = list[idx];
    if (item && item.name === name) {
      return { item, index: idx };
    }
  }
  return null;
};

export const replaceItemInListByName = (list, item) => {
  if (!list || !item || !item.name) { return list; }
  const clonedList = [...list];
  const listItem = getItemFromListByName(clonedList, item.name);
  if (listItem) {
    clonedList[listItem.index] = item;
  }
  return clonedList;
};

export const formatPhoneNumber = (phone) => {
  if (typeof phone === 'undefined') {
    return '';
  }
  // strip non-digit chars
  phone = phone.replace(/[^a-z0-9]/gi, '');
  phone = phone.substring(0, 10);

  var size = phone.length;
  if (size === 0) {
    return phone;
  } else if (size < 4) {
    phone = '(' + phone;
  } else if (size < 7) {
    phone = '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6);
  } else {
    phone = '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + ' - ' + phone.substring(6, 10);
  }
  return phone;
};

export const getStateCodeOptions = () => {
  var options = [{
    text: 'ALL',
    value: ''
  }];
  var codes = STATE_CODES;
  Object.keys(codes).map(state => options.push({ text: state, value: state }));
  return options;
};

export const getEmailRemainderOptions = () => {
  const options = [];
  const emailRemainders = REMAINDER_EMAIL_MINUTES;
  emailRemainders.map(reminder => options.push({ value: parseInt(reminder[0]), text: reminder[1] }));
  return options;
};

export const getPushNotificationRemainderOptions = () => {
  const options = [];
  const pushNotificationRemainders = REMAINDER_PUSH_NOTIFICATION_MINUTES;
  pushNotificationRemainders.map(reminder => options.push({ value: parseInt(reminder[0]), text: reminder[1] }));
  return options;
};

export const formatAmount = (amount, skipDollarSign, addComma) => {
  if (amount && amount.length > 0) {
    if (addComma) {
      // regex to remove dollar and comma
      amount = amount.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/(.*)\.$/, '$1');
    } else {
      amount = amount.replace(/[^\d.,]/g, '').replace(/^\./, '');
    }

    if (amount.match(/(.*?)\.\d+/)) {
      // consider only two digits after decimal point
      amount = amount.replace(/([\d,]+(\.\d{1,2})?).*/, '$1');
    }

    if (amount.length > 0) {
      var prefix = '$';
      if (skipDollarSign) {
        prefix = '';
      }

      if (addComma) {
        // regex to add comma
        amount = amount.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      }

      return prefix + amount;
    }
  }
  return amount;
};

const testValue = (value) => {
  if (typeof value === 'undefined') {
    return '';
  } else {
    return value;
  }
};

export const addressConcat = (address) => {
  if (typeof address === 'undefined') { return; }
  const city = testValue(address.city);
  const state = testValue(address.stateOrProvince);
  const zipCode = testValue(address.postalCode);

  if ((!!city) && (!!state)) {
    return `${city}, ${state} ${zipCode}`;
  } else {
    return `${city} ${state} ${zipCode}`;
  }
};

export const convertNull = (value) => {
  if (value === null) {
    return 'null';
  } else if (value === 'null') {
    return null;
  }
};

export const getWeeklyStatusDescription = (status) => {
  switch (status) {
    case 'Customer Undecided':
      return OPPORTUNITY_STATUS_DESCRIPTION.CUSTOMER_UNDECIDED;
    case 'Actively Shopping':
      return OPPORTUNITY_STATUS_DESCRIPTION.ACTIVELY_SHOPPING;
    case 'Customer Not Moving Forward':
      return OPPORTUNITY_STATUS_DESCRIPTION.CUSTOMER_NOT_MOVING_FORWARD;
    case 'Customer Not Ready To Transact In 3 Months':
      return OPPORTUNITY_STATUS_DESCRIPTION.CUSTOMER_NOT_READY_TO_TRANSACT_IN_3MONTHS;
    case 'Customer Intends to List':
      return OPPORTUNITY_STATUS_DESCRIPTION.CUSTOMER_INTENDS_TO_LIST;
    case 'On-Hold Customer Intent':
      return OPPORTUNITY_STATUS_DESCRIPTION.ON_HOLD_CUSTOMER_INTENT;
    case 'Pending Appointment':
      return OPPORTUNITY_STATUS_DESCRIPTION.PENDING_APPOINTMENT;
    case 'Touring Properties':
      return OPPORTUNITY_STATUS_DESCRIPTION.TOURING_PROPERTIES;
    case 'Pre List':
      return OPPORTUNITY_STATUS_DESCRIPTION.PRE_LIST;
    case 'Listed':
      return OPPORTUNITY_STATUS_DESCRIPTION.LISTED;
    default:
      return null;
  }
};
